const agentActivityPriceRanges = (for_sale_price, recently_sold_price) => {
  let for_sale_price_data = shouldConsiderPriceRange(for_sale_price);
  let recently_sold_price_data = shouldConsiderPriceRange(recently_sold_price);
  let min, max, priceRange;
  if (for_sale_price_data.length > 0 && recently_sold_price_data.length > 0) {
    let compact = [...for_sale_price_data, ...recently_sold_price_data];
    min = Math.min(...compact);
    max = Math.max(...compact);
    priceRange = { min, max };
  } else if (for_sale_price_data.length > 0) {
    priceRange = { min: for_sale_price_data[0], max: for_sale_price_data[1] };
  } else if (recently_sold_price_data.length > 0) {
    priceRange = { min: recently_sold_price_data[0], max: recently_sold_price_data[1] };
  } else {
    priceRange = {};
  }

  return priceRange;
};
const shouldConsiderPriceRange = (range) => {
  let rangeArr = [];
  if (range && "min" in range && "max" in range) {
    if (range["min"] && range["max"] && range["max"] > 0 && range["min"] > 0) {
      rangeArr.push(range["min"]);
      rangeArr.push(range["max"]);
    }
  }
  return rangeArr;
};

module.exports = {
  agentActivityPriceRanges,
};
